import React from 'react';
import { Image } from 'react-bootstrap';
import PropTypes from 'prop-types';
import Slider from 'react-slick';
import classNames from 'classnames';
import { useSelector } from 'react-redux';
import noPhoto from 'assets/img/generic/no-photo-available.png';

const sliderSettings = {
  autoplay: false,
  infinite: true,
  speed: 500,
  slidesToShow: 1,
  slidesToScroll: 1
};

const ListingSingleImage = ({ image, layout }) => {
  const { restURI } = useSelector(state => state.config);

  return (
    <Image
      rounded={layout === 'list'}
      src={`${restURI}/files/${image.id}`}
      className={classNames('h-100 w-100 fit-cover', {
        'rounded-top': layout === 'grid'
      })}
      alt={image.fileName}
      fluid
    />
  );
};

const ListingImages = ({ images, layout }) => {
  return (
    <div
      className={classNames('position-relative rounded-top overflow-hidden', {
        'h-sm-100': layout === 'list'
      })}
    >
      {images.length === 0 && (
        <Image
          rounded={layout === 'list'}
          src={noPhoto}
          className={classNames('h-100 w-100 fit-cover', {
            'rounded-top': layout === 'grid'
          })}
          fluid
        />
      )}
      {images.length === 1 && (
        <ListingSingleImage
          key={images[0].id}
          image={images[0]}
          layout={layout}
        />
      )}
      {images.length > 1 && (
        <Slider
          {...sliderSettings}
          className="product-image-slider slick-slider-arrow-inner h-100 full-height-slider"
        >
          {images.map(image => (
            <ListingSingleImage key={image.id} image={image} layout={layout} />
          ))}
        </Slider>
      )}
    </div>
  );
};

ListingSingleImage.propTypes = {
  image: PropTypes.shape({
    id: PropTypes.string.isRequired,
    fileName: PropTypes.string.isRequired
  }),
  layout: PropTypes.string.isRequired
};

ListingImages.propTypes = {
  images: PropTypes.array.isRequired,
  layout: PropTypes.string.isRequired
};

export default ListingImages;
